module.exports = __webpack_public_path__ + "fonts/boxicons.deea39cb.woff";